import Evee from 'evee';
import ls from 'local-storage';
import _ from 'lodash';
import EventBus from './EventBus.js';

class TrackQueue extends Evee {
    constructor() {
        super();

        this.items = [];    // 0 - next to play
        this.current = null;// now playing
        this.history = [];  // 0 - last played
    }

    serialize() {
        ls('pp-queue', {
            items: this.items,
            current: this.current,
            history: this.history
        });
    }

    deserialize() {
        var saved = ls.get('pp-queue');
        console.log('saved', saved);
        if (saved) {
            EventBus.emit('core.track.play', {
                track: saved.current,
                context: _.concat(saved.history, saved.current, saved.items),
                mode: null,
                stayPaused: true
            });
        }
        //this.emit('changed', {});
    }

    clear() {
        this._clear();
        this.emit('changed', {});
    }

    _clear() {
        this.items = [];
        this.current = null;
        this.history = [];
    }

    initSingle(track) {
        this._clear();
        this.current = track;
        this.emit('changed', {});
    }

    initContext(track, tracklist, mode) {
        if (!mode) {
            let index = tracklist.indexOf(track);
            if (index > -1) {
                let before = tracklist.slice(0, index);
                let after = tracklist.slice(index + 1);

                this.history = before.reverse();
                this.items = after;
            } else {
                this.items = tracklist;
            }
            this.current = track;
        }
        if (mode == 'from-history') {
            let index = this.history.indexOf(track);
            if (index > -1) {
                let before = this.history.slice(0, index);
                let after = this.history.slice(index + 1);

                let newQueue = before;
                if (this.current) {
                    newQueue.push(this.current);
                }
                newQueue = newQueue.concat(this.items);

                this.history = after;
                this.items = newQueue;
                this.current = track;
            } else {
                throw Error('Attempted to play from history context: track not found in history.');
            }
        }
        if (mode == 'from-queue') {
            let index = this.items.indexOf(track);
            if (index > -1) {
                let before = this.items.slice(0, index);
                let after = this.items.slice(index + 1);

                let newHistory = before;
                if (this.current) {
                    newHistory.push(this.current);
                }
                newHistory = newHistory.concat(this.history);

                this.history = newHistory;
                this.items = after;
                this.current = track;
            } else {
                console.log(this.items);
                console.log(track);
                throw Error('Attempted to play from queue context: track not found in queue.');
            }
        }

        this.addUnshuffleMarkers();

        this.emit('changed', {});
    }

    addUnshuffleMarkers() {
        let i = 0;
        for (var j = 0; j < this.history.length; j++) {
            this.history[j].__queue_index = i;
            i++;
        }
        if (this.current) {
            this.current.__queue_index = i;
            i++;
        }
        for (var j = 0; j < this.items.length; j++) {
            this.items[j].__queue_index = i;
            i++;
        }
    }

    unshuffle() {
        var newFullQueue = this.history;
        if (this.current) {
            newFullQueue.push(this.current);
        }
        newFullQueue = newFullQueue.concat(this.items);

        newFullQueue = newFullQueue.sort((a, b) => {
            if (a.__queue_index < b.__queue_index) {
                return -1;
            } else {
                return 1;
            }
        });


        let index = newFullQueue.indexOf(this.current);
        if (index > -1) {
            let before = newFullQueue.slice(0, index);
            let after = newFullQueue.slice(index + 1);

            this.history = before;
            this.items = after;
        } else {
            this.items = newFullQueue;
        }

        this.emit('changed', {});
    }



    next() {
        var success = this._next();
        this.emit('changed', {});
        return success;
    }

    prev() {
        var success = this._prev();
        this.emit('changed', {});
        return success;
    }

    _prev() {
        if (this.current) {
            this.items.unshift(this.current);
        }
        if (this.history.length > 0) {
            this.current = this.history.shift();
            return true;
        } else {
            this.current = null;
            return false;
        }
    }

    _next() {
        if (this.current) {
            this.history.unshift(this.current);
        }
        if (this.items.length > 0) {
            this.current = this.items.shift();
            return true;
        } else {
            this.current = null;
            return false;
        }
    }

    canNext() {
        return this.items.length > 0;
    }

    canPrevious() {
        return this.history.length > 0;
    }

    restart(shuffle, fromEnd) {
        let fullQueue = this.history.reverse();
        if (this.current) {
            fullQueue.push(this.current);
        }
        fullQueue = fullQueue.concat(this.items.reverse());

        if (fromEnd) {
            this.history = fullQueue;
            this.items = [];

            if (shuffle && this.history.length > 2) {
                this.history = this._shuffle(this.history);
            }

            this._prev();
        } else {
            this.history = [];
            this.items = fullQueue;

            if (shuffle && this.items.length > 2) {
                this.items = this._shuffle(this.items);
            }

            this._next();
        }
        this.emit('changed', {});
    }

    remove(mode, index) {
        console.log('REMOVE', mode);
        console.log('REMOVE', index);
        if (!mode) {
            this.current = null;
            this._next();
        } else if (mode == 'from-history') {
            var history = this.history;
            history.splice(index, 1);
            this.history = history;
        } else if (mode == 'from-queue') {
            let items = this.items;
            items.splice(index, 1);
            this.items = items;
            console.log(items);
        }
        this.emit('changed', {});
    }

    add(track, next) {
        if (next) {
            this.items.unshift(track);
        } else {
            this.items.push(track);
        }
    }

    shuffle() {
        var newFullQueue = this.items;
        if (this.current) {
            newFullQueue.push(this.current);
        }
        newFullQueue = newFullQueue.concat(this.history);

        newFullQueue = this._shuffle(newFullQueue);

        let index = newFullQueue.indexOf(this.current);
        if (index > -1) {
            let before = newFullQueue.slice(0, index);
            let after = newFullQueue.slice(index + 1);

            this.history = before;
            this.items = after;
        } else {
            this.items = newFullQueue;
        }

        this.emit('changed', {});
    }

    _shuffle(array) {
        let counter = array.length;

        // While there are elements in the array
        while (counter > 0) {
            // Pick a random index
            let index = Math.floor(Math.random() * counter);

            // Decrease counter by 1
            counter--;

            // And swap the last element with it
            let temp = array[counter];
            array[counter] = array[index];
            array[index] = temp;
        }

        return array;
    }
}


export default new TrackQueue();



// WEBPACK FOOTER //
// ./src/TrackQueue.js